import { apiCall, secondaryApi } from './ApiUtils'

export const addSite = (token, form) => apiCall(`sites`, {
    method: 'POST',
    body: form
}, token)

export const updateSite = (siteId, token, form) => apiCall(`sites/${siteId}`, {
    method: 'PUT',
    body: form
}, token)

export const deleteSiteService = (siteId, type) => apiCall(`sites/${siteId}/accounts/${type}`, {
    method: 'DELETE'
}, null, secondaryApi)

export const deleteSiteById = (siteId) => apiCall(`sites/${siteId}`, {
    method: 'DELETE'
})

export const uploadLogo = (logoFile) => {
    let data = new FormData()
    data.append("logo", logoFile)
    
    return apiCall(`sites/logo`, {
        method: 'POST',
        body: data
    }, null, secondaryApi, null, false, true)
}